import ServiceTag, { TagGroup } from './ServiceTag.styled';
import { SKINS } from './ServiceTag';
import React from 'react';

const ServiceTagFTC = (props) => (
  <ServiceTag text="FTC" skin={SKINS.success} textTransform="uppercase" weight="bold" {...props} />
);

const ServiceTagFleetService = (props) => (
  <ServiceTag
    text="SF"
    skin={SKINS.grey}
    weight="bold"
    textTransform="Uppercase"
    title="Service Fleet"
    {...props}
  />
);

export default ServiceTag;
export { SKINS, TagGroup };
export { ServiceTagFTC, ServiceTagFleetService };
